import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "../security/privateRoute";
import { MenuItem } from "common/components/layout/menu/menuTypes";
import Dashboard from "./dashboard";
import Permissions from "./permissions";
import FirstContainers from "./firstContainerRegistry";
import Containers from "./containers";
import Users from "./users";
import Dispensaries from "./dispensaries";
import DispensarySale from "./dispensarySale";
import HoseSale from "./hoseSale";
import EntryVolumeMeasurer from "./entryVolumeMeasurer";
import PGRegistration from "./receptions/components/pgRegistration";
import Printer from "./printer";
import Backups from "./backups";
import Alerts from "./alerts";
import Logbook from "./logbook";
import Dictums from "./dictums/page";
import DictumForm from "./dictums/components/DictumForm";
import OperationCertificates from "./certificates/page";
import FirstConfigApplication from "./firstConfigApplication";
import ConfigurationApplication from "./configurationApplication";
import OutputEmailConfig from "./configurationOutputEmail";
import HealthInformation from "./healthApplication";
import PermissionNumbers from "./permissionNumbers";
import CorruptedDataVisualizer from "./corruptedDataVisualizer";
import VolumeMeasurerConfig from "./volumeMeasurerRegistries";
import FirstWarehouses from "./firstWarehouseRegistry";
import Warehouses from "./wareHouse";
import EmailSenderConfig from "./emailSenderConfigutarion";
import ComplementsComponent from "./cfdiComplements/ComplementsComponent";
import Traspasos from "./Traspasos";
import JsonReport from "./jsonReport/page";
import Subscriptions from "./subscriptions";
import UpsertDistributionPoint from "./distributionPoints/UpsertDistributionPoint";
import MainLayout from "../common/components/layout/main/MainLayout";
import StockControl from "./stockControl/StockControl";
import DistributionPointsScreen from "./distributionPoints/DistributionPointsScreen";
import CheckStatusPage from "./home/CheckStatusPage";
import UploadCFDIs from "./upload/CFDIs/UploadCFDIs";
import UploadJsonSATReport from "./upload/SATReport/UploadJsonSATReport";
import ReceptionScreen from "./receptions/ReceptionScreen";

interface RoutesProps {
  menu: MenuItem[];
}

const Routes: React.FC<RoutesProps> = ({ menu }) => {
  return (
    <Router basename="/cv">
      <MainLayout menu={menu}>
        <Switch>
          <Route
            path="/receptions/components/pgRegistration/:id/:inputRegister"
            component={PGRegistration}
          />
          <Route
            path="/distributionPoints/:distributionPointId"
            component={UpsertDistributionPoint}
          />

          {menu.map((item) => {
            const { secure, path, component: Component, ...rest } = item;

            return secure ? (
              <PrivateRoute exact path={path} component={Component} {...rest} />
            ) : (
              <Route exact path={path} component={Component} {...rest} />
            );
          })}
        </Switch>
      </MainLayout>
    </Router>
  );
};

export {
  Dashboard,
  Permissions,
  CheckStatusPage,
  FirstContainers,
  Containers,
  Users,
  Dispensaries,
  DispensarySale,
  HoseSale,
  EntryVolumeMeasurer,
  ReceptionScreen,
  PGRegistration,
  StockControl,
  Printer,
  Backups,
  Alerts,
  Logbook,
  Dictums,
  OperationCertificates,
  FirstConfigApplication,
  ConfigurationApplication,
  OutputEmailConfig,
  HealthInformation,
  PermissionNumbers,
  CorruptedDataVisualizer,
  VolumeMeasurerConfig,
  FirstWarehouses,
  Warehouses,
  EmailSenderConfig,
  ComplementsComponent,
  DistributionPointsScreen,
  Traspasos,
  JsonReport,
  Subscriptions,
  DictumForm,
  UpsertDistributionPoint,
  UploadCFDIs,
  UploadJsonSATReport,
};

export default Routes;
